import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Sidebar = ({ activePage, setActivePage, isCollapsed, setIsCollapsed }) => {
  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊' },
    { id: 'business', label: 'Business Collection', icon: '💼' },
    { id: 'client', label: 'Client', icon: '👥' },
    { id: 'system', label: 'System', icon: '⚙️' },
    { id: 'license', label: 'License', icon: '🔑' },
    { id: 'payment', label: 'Payment', icon: '💰' },
    { id: 'logs', label: 'Business Logs', icon: '📝' },
  ];

  return (
    <div 
      className={`
        bg-gray-800 
        text-white 
        transition-all 
        duration-300 
        fixed 
        top-0 
        left-0 
        h-screen 
        overflow-y-auto
        ${isCollapsed ? 'w-20' : 'w-64'}
        z-50
        flex
        flex-col
      `}
    >
      {/* Logo and Toggle */}
      <div className="p-4 border-b border-gray-700 flex items-center justify-between flex-shrink-0">
        {!isCollapsed && <h1 className="text-xl font-bold">License Management</h1>}
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="p-1 rounded hover:bg-gray-700 transition-colors"
          aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {isCollapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
        </button>
      </div>
      
      {/* Navigation */}
      <nav className="p-4 flex-1 overflow-y-auto">
        <ul className="space-y-2">
          {menuItems.map((item) => (
            <li key={item.id}>
              <button
                onClick={() => setActivePage(item.id)}
                className={`
                  w-full 
                  text-left 
                  px-4 
                  py-3 
                  rounded-lg 
                  transition-colors 
                  flex 
                  items-center 
                  ${isCollapsed ? 'justify-center px-2' : 'space-x-3'}
                  ${activePage === item.id
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                  }
                `}
                title={isCollapsed ? item.label : ''}
              >
                {/* Increased visibility with white text and shadow */}
                <span className="text-xl flex-shrink-0 text-white drop-shadow-sm">
                  {item.icon}
                </span>
                {!isCollapsed && <span className="truncate font-semibold">{item.label}</span>}
              </button>
            </li>
          ))}
        </ul>
      </nav>

      {/* Optional: Add a spacer at the bottom if you want to add logout button later */}
      <div className="p-4 border-t border-gray-700 flex-shrink-0">
        {!isCollapsed && (
          <div className="text-xs text-gray-400 text-center">
            License Management System
          </div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;